export const navaApp = [
    {
        title: "نسخه ویندوز",
        url: "https://dl.navatel.ir/Navatel.msi",
        icon: "cib:windows",
        version: "3.9.0",
    },
    {
        title: "نسخه اندروید",
        url: "https://dl.navatel.ir/Navatel.apk",
        icon: "cib:android-alt",
        version: "3.9.0",
    },
    {
        title: "نسخه IOS",
        url: "https://sibapp.com/applications/Navatel",
        icon: "cib:apple",
        version: "",
    },
    {
        title: "نسخه لینوکس",
        url: "https://dl.navatel.ir/navatel.deb",
        icon: "cib:linux",
        version: "3.9.0",
    },
    {
        title: "نسخه وب‌اپلیکیشن",
        url: "https://app.navatel.ir/",
        icon: "solar:global-bold",
        version: "",
    },
];

export const metamaApp = [
    {
      title: "نسخه ویندوز",
      icon: "cib:windows",
      url: "https://navatel.ir/metama/download/windows/",
      version: "1.1.3",
    },
    {
      title: "نسخه ios",
      icon: "cib:apple",
      url: "https://anardoni.com/ios/app/comnorthsolutionsmetama",
      version: "1.1.3",
    },
    {
      title: "نسخه اندروید",
      icon: "cib:android-alt",
      url: "https://navatel.ir/metama/download/android/",
      version: "",
    },
    {
      title: "نسخه وب‌اپلیکیشن",
      icon: "solar:global-bold",
      url: "https://app.matama.ir/",
      version: "",
    },
]